import { Box, Center } from '@mantine/core'
import { CompassRose } from './marina/CompassRose'
import classes from './PageLoader.module.css'

/**
 * Branded loading indicator. Compass rose (Pelabuhan design language)
 * rotates slowly — matches the splash screen + sidebar brand mark.
 *
 * - `inline`: smaller, no full-viewport center (use inside cards/lists).
 * - `label`: optional caption beneath the mark (default "Memuat").
 */
export function PageLoader({ inline = false, label = 'Memuat' }: { inline?: boolean; label?: string | null }) {
  const content = (
    <div className={classes.content}>
      <div className={`${classes.mark} ${inline ? classes.markSm : ''}`} aria-hidden="true">
        <CompassRose size={inline ? 22 : 32} color="white" />
      </div>
      {label && <div className={classes.label}>{label}</div>}
    </div>
  )

  if (inline) {
    return (
      <Box className={classes.inlineWrap} role="status" aria-busy="true" aria-label={label ?? 'Memuat'}>
        {content}
      </Box>
    )
  }

  return (
    <Center className={classes.fullWrap} role="status" aria-busy="true" aria-label={label ?? 'Memuat'}>
      {content}
    </Center>
  )
}
